/**
 * Identity signature for a list of DB-backed card items.
 *
 * The card components (LinkedIn carousel, Meta carousel feed/story, Snapchat
 * story) each hold their cards in local state, seeded from an `initialItems`
 * prop. Seeding used to be guarded by a once-only `seededRef`, which made the
 * components depend entirely on the parent remounting them (via `formKey`) to
 * pick up new data.
 *
 * That coupling broke whenever the remount didn't fire. The parent's `formKey`
 * was built from card COUNTS, so deleting one card and adding another produced
 * an identical key — no remount, no re-seed, and the cards kept rendering the
 * previous assets (blank thumbnails, since those blob URLs had been revoked).
 *
 * Keying on identity rather than count means re-seeding is driven by *which*
 * assets are present. `existingAssetId` is the stable identifier; `imageUrl` is
 * the fallback for text-only or not-yet-persisted rows. Positional index is
 * included so pure reorders re-seed too.
 */
export function seedSignature(
  items: { existingAssetId?: string; imageUrl?: string }[] | undefined,
): string {
  if (!items?.length) return '';
  return items.map((it, i) => `${i}:${it.existingAssetId ?? it.imageUrl ?? '∅'}`).join('|');
}
